import { render } from "./UpgradeVillagerModal.vue?vue&type=template&id=30395d16&scoped=true"
import script from "./UpgradeVillagerModal.vue?vue&type=script&lang=js"
export * from "./UpgradeVillagerModal.vue?vue&type=script&lang=js"

import "./UpgradeVillagerModal.vue?vue&type=style&index=0&id=30395d16&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30395d16"]])

export default __exports__